import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
export function renderAdminLeadsTable({ getSortAttributes, searchHtml }) {
    const columns = getColumns(getSortAttributes);
    return renderKoDataTable({
        title: 'Leads',
        titleIcon: 'users',
        caption: 'Submitted recruiting leads',
        columns,
        actions: searchHtml,
        className: 'admin-leads-table',
        children: renderBody(columns),
    });
}
export function renderAdminLeadPartnersTable() {
    const columns = getPartnerColumns();
    return String(LpTable.Root({
        caption: 'Lead partner delivery details',
        columns,
        className: 'admin-leads-partners-table__table',
        children: html `
            ${LpTable.Header({
            children: LpTable.Row({
                children: columns.map((column) => LpTable.Head({ column })),
            }),
        })}
            ${LpTable.Body({
            attributes: { 'data-bind': 'foreach: partners' },
            children: LpTable.Row({
                children: html `
                        ${renderRecruitingTextCell({ column: columns[0], binding: '$data.id || "-"' })}
                        ${renderRecruitingTextCell({ column: columns[1], binding: '$data.transmissionId || "-"' })}
                        ${renderRecruitingTextCell({ column: columns[2], binding: '$data.sendFlag || "-"' })}
                        ${renderRecruitingTextCell({ column: columns[3], binding: '$data.campaignCode || "-"' })}
                    `,
            }),
        })}
        `,
    }));
}
function getColumns(getSortAttributes) {
    return [
        { key: 'select', label: '', align: 'center', width: 56, minWidth: 48, required: true },
        { key: 'id', label: 'ID', sortable: true, sortAttributes: getSortAttributes('id'), width: 112, minWidth: 88, resizable: true },
        { key: 'email', label: 'Email', sortable: true, sortAttributes: getSortAttributes('email'), width: 240, minWidth: 180, resizable: true },
        { key: 'channel', label: 'Channel', sortable: true, sortAttributes: getSortAttributes('channelId'), width: 144, minWidth: 120, resizable: true },
        { key: 'subunit', label: 'Subunit', sortable: true, sortAttributes: getSortAttributes('subunitId'), width: 220, minWidth: 160, resizable: true },
        { key: 'createdDate', label: 'Created Date', sortable: true, sortAttributes: getSortAttributes('createdDate'), width: 188, minWidth: 156, resizable: true },
        { key: 'externalSource', label: 'External Source', sortable: true, sortAttributes: getSortAttributes('externalSource'), width: 180, minWidth: 144, resizable: true },
        { key: 'internalSource', label: 'Internal Source', sortable: true, sortAttributes: getSortAttributes('internalSource'), width: 180, minWidth: 144, resizable: true },
        { key: 'state', label: 'State', sortable: true, sortAttributes: getSortAttributes('state'), width: 112, minWidth: 88, resizable: true },
        { key: 'selectedPartners', label: 'Selected Partners', minWidth: 280, resizable: true },
        { key: 'actions', label: 'Actions', align: 'center', width: 96, minWidth: 88, required: true },
    ];
}
function getPartnerColumns() {
    return [
        { key: 'partnerId', label: 'Partner ID', width: 128, minWidth: 112 },
        { key: 'transmissionId', label: 'Transmission ID', width: 152, minWidth: 128 },
        { key: 'sendFlag', label: 'Send Flag', width: 120, minWidth: 104 },
        { key: 'campaignCode', label: 'Campaign Code', minWidth: 160 },
    ];
}
function renderBody(columns) {
    return html `
        ${LpTable.Body({
        attributes: { 'data-bind': 'foreach: rows' },
        children: LpTable.Row({
            attributes: { 'data-bind': 'css: { "is-selected": selected }' },
            children: html `
                    ${LpTable.Cell({
                column: columns[0],
                children: html `<input type="checkbox" data-bind="checked: selected, event: { change: function () { $parent.rows.valueHasMutated(); } }" />`,
            })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: 'id' })}
                    ${renderRecruitingTextCell({ column: columns[2], binding: '$data.email || ""', titleBinding: '$data.email || ""' })}
                    ${renderRecruitingTextCell({ column: columns[3], binding: '$data.channelName || $data.channel || ""', titleBinding: '$data.channelName || $data.channel || ""' })}
                    ${renderRecruitingTextCell({ column: columns[4], binding: '$data.subunitName || $data.subunit || ""', titleBinding: '$data.subunitName || $data.subunit || ""' })}
                    ${renderRecruitingTextCell({ column: columns[5], binding: '$data.createdDateLabel || $data.createdDate || $data.dateCreated || ""' })}
                    ${renderRecruitingTextCell({ column: columns[6], binding: '$data.externalSource || ""', titleBinding: '$data.externalSource || ""' })}
                    ${renderRecruitingTextCell({ column: columns[7], binding: '$data.internalSource || ""', titleBinding: '$data.internalSource || ""' })}
                    ${renderRecruitingTextCell({ column: columns[8], binding: '$data.state || ""' })}
                    ${renderRecruitingTextCell({ column: columns[9], binding: '$data.partnersLabel || ""', clampLines: 2, titleBinding: '$data.partnersLabel || ""' })}
                    ${LpTable.Cell({ column: columns[10], children: LpButton({ ariaLabel: 'View lead', prefixIcon: 'eye', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickViewLead' } }) })}
                `,
        }),
    })}
        ${renderKoEmptyState({ colSpan: columns.length, visibleBinding: 'rows().length === 0', title: 'No leads found', description: 'No leads match the selected filters.', icon: 'users' })}
    `;
}
